
import VueFilters from "@/vue-filters";
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  ICountryConfig,
  IField,
  ISolCustomerCurrency,
  ISolCustomerDenominationPack,
  ISolCustomerPack,
  IValuePack,
} from "@/entities";
import { Getter } from "vuex-class";
import IconEdit from "@/components/common/icon/IconEdit.vue";
import IconTrash from "@/components/common/icon/IconTrash.vue";
import { PropType } from "vue";

@Component({
  name: "declared-value-pack-details",
  components: { IconTrash, IconEdit },
  mixins: [VueFilters],
})
export default class DeclaredValuePackDetails extends Vue {
  @Prop({ required: false, default: () => [], type: Array as PropType<IValuePack[]> })
  values!: IValuePack[];
  @Prop({ required: false, default: false, type: Boolean }) edit!: boolean;
  @Prop({ required: true }) packs!: ISolCustomerPack[];
  @Getter("getCountryConfig") countryConfig!: ICountryConfig;
  @Getter("getSolCustomerCurrencies") solCustomerCurrencies!: ISolCustomerCurrency[];

  get visibleFieldsValues(): IField[] {
    return this.fieldsValues.filter((field) => field.visible !== false);
  }

  get fieldsValues(): IField[] {
    return [
      {
        key: "actions-left",
        label: "",
        sortable: false,
        thClass: "table-header table-header-active pl-4",
        tdClass: "table-cell-first align-middle position-relative",
      },
      {
        key: "pc",
        label: this.$t("label.pack") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
        formatter: (value) => {
          const pack = this.packs.find((p) => p.code === value);
          return pack ? pack.description : value;
        },
      },
      {
        key: "pq",
        label: this.$t("label.quantity") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
      },
      {
        key: "am",
        label: this.$t("column.amount") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
      },
      {
        key: "actions-right",
        label: "",
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-last align-middle",
      },
    ];
  }

  onClickEdit(value: IValuePack): void {
    this.$emit("edit", value);
  }

  onClickDelete(value: IValuePack): void {
    this.values.splice(this.values.indexOf(value), 1);
  }

  getCurrencySymbol(currencyIsoCode: string): string {
    const currency = this.solCustomerCurrencies.find(
      (currency) => currency.isoCode === currencyIsoCode
    );
    return currency?.symbol || "";
  }

  sumAmounts(
    valuePack?: IValuePack
  ): { amount: number; currencySymbol: string; currencyIsoCode: string }[] {
    const amounts: { amount: number; currencySymbol: string; currencyIsoCode: string }[] = [];
    const packQuantity = valuePack?.pq || 0;
    const packCode = valuePack?.pc || "";
    const currencyIsoCode = valuePack?.cic || "";
    const currencySymbol = this.getCurrencySymbol(currencyIsoCode);

    if (packQuantity && packCode) {
      const pack = this.packs.find((p) => p.code === packCode);

      if (pack) {
        let amountByCurrency = amounts.find((a) => a.currencySymbol === currencySymbol);

        if (amountByCurrency) {
          amountByCurrency.amount += packQuantity * this.sumDenominations(pack.denominations);
        } else {
          amounts.push({
            amount: packQuantity * this.sumDenominations(pack.denominations),
            currencySymbol: currencySymbol,
            currencyIsoCode: currencyIsoCode,
          });
        }
      }
    }
    return amounts;
  }

  sumDenominations(denominations: ISolCustomerDenominationPack[] | undefined): number {
    let amount = 0;

    denominations?.forEach(
      (denomination) => (amount += (denomination?.quantity || 0) * (denomination?.value || 0))
    );

    return amount;
  }
}
